import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material"; // Assuming you're using Material-UI
import holdImage from "../../assests/images/hold.png";

const SuccessModal = ({ open, onClose, message }) => {
    const style = { margin: '33px 0' };
    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box
                sx={{
                    position: "absolute",
                    top: "290px",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "500px !important",
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    padding: "10px",
                    textAlign: "center", borderRadius: "9px"
                }}
            >
                <div className="modal-header" style={{ borderBottom: 'none', padding: '0px' }}>
                    <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        fdprocessedid="kum8iho"
                        onClick={() => onClose()}
                    ></button>
                </div>
                <img src={holdImage} alt="" />
                <Typography variant="body1" style={{ margin: '10px 0', fontWeight: '700' }}><span>{message}</span></Typography>
                <Button onClick={onClose} variant="contained" style={{ marginBottom: '19px' }}>Done</Button>
            </Box>
        </Modal>
    );
};

export default SuccessModal;